import { Contract } from "@/utils/contract";
import { postApi } from "@/utils/fetch";
import { SearchMansionRequest, SearchMansionResponse } from "./property";

export const fetchContractAsync = (abort: AbortController, contractSearchId: string, useExpired: boolean) => {
  return postApi<Contract>("/api/contract/search", {
    body: JSON.stringify({ contractSearchId, useExpired }),
  });
};

export type ContractSearchMansionRequest = SearchMansionRequest & {
  contractId: number;
};

export const contractSearchMansion = async (
  abort: AbortController,
  params: ContractSearchMansionRequest
): Promise<SearchMansionResponse[]> => {
  return postApi<SearchMansionResponse[]>("/api/contract/search/mansions", {
    body: JSON.stringify(params),
  });
};
